var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  SVG.prototype.render = function render() {
    return React.createElement(
      "svg",
      _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, this.props),
      React.createElement("path", { d: "M19.602 2c.099 0 .183.034.252.1.68.657 1.36 1.312 2.037 1.97.147.142.143.347.002.493l-.075.072c-2.487 2.407-4.974 4.813-7.459 7.222a.804.804 0 0 1-.433.226c-.796.148-1.59.305-2.384.458-.278.054-.493-.156-.437-.427.167-.806.335-1.613.5-2.42a.436.436 0 0 1 .135-.231l5.242-5.074 2.34-2.267a.38.38 0 0 1 .28-.122" }),
      React.createElement("path", { d: "M5.804 5.483v12.185h12.594v-.09-6.847c0-.416.264-.757.666-.864.558-.148 1.119.255 1.133.815v7.826a.86.86 0 0 1-.425.776.847.847 0 0 1-.442.13h-.084c-4.764 0-9.528 0-14.292.002-.33 0-.594-.112-.788-.37a.796.796 0 0 1-.164-.47v-.088c0-4.606 0-9.211-.002-13.817 0-.32.113-.58.382-.77a.858.858 0 0 1 .478-.158l.083-.002h8.027c.394 0 .717.202.86.536.242.564-.175 1.185-.808 1.205l-.106.001H5.804z" })
    );
  };

  return SVG;
}(React.Component);

export { SVG as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper-icons/es/components/ic_edit_24px.svg.react.js
// module id = null
// module chunks = 